import Page from 'components/ui/Page'
import { lazy, Suspense } from 'react'

/**
 * Lazy-loaded so the builder (and its `@react-email/*` dependency tree)
 * ships as its own chunk, fetched only when this route is visited.
 */
const EmailBuilderPageContent = lazy(
    () => import('components/marketing/emailBuilder/EmailBuilderPageContent'),
)

const EmailBuilderPage = () => {
    return (
        <Page title="Email builder">
            <Suspense fallback={null}>
                <EmailBuilderPageContent />
            </Suspense>
        </Page>
    )
}

export default EmailBuilderPage
